function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

function inferVideoExtension(videoUrl) {
  try {
    const pathname = new URL(videoUrl, window.location.origin).pathname;
    const match = pathname.match(/\.(mp4|webm|mov)$/i);
    if (match) return match[1].toLowerCase();
  } catch {
    // Ignore malformed URLs and fall back to mp4.
  }
  return 'mp4';
}

/**
 * Download a flythrough video from a presigned or blob URL.
 * @param {string} videoUrl
 * @param {string} [filenameBase='flythrough']
 */
export async function downloadFlythroughVideo(videoUrl, filenameBase = 'flythrough') {
  const trimmed = typeof videoUrl === 'string' ? videoUrl.trim() : '';
  if (!trimmed) {
    throw new Error('No video URL');
  }

  const extension = inferVideoExtension(trimmed);
  const filename = `${filenameBase}-${Date.now()}.${extension}`;

  try {
    const response = await fetch(trimmed, { mode: 'cors', referrerPolicy: 'no-referrer' });
    if (!response.ok) {
      throw new Error(`Download failed (${response.status})`);
    }
    const blob = await response.blob();
    triggerBlobDownload(blob, filename);
    return;
  } catch (err) {
    console.warn('Flythrough video blob download failed, trying direct link:', err);
  }

  const anchor = document.createElement('a');
  anchor.href = trimmed;
  anchor.download = filename;
  anchor.rel = 'noopener noreferrer';
  anchor.referrerPolicy = 'no-referrer';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
